//@author: mandy

import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    NgZone,
    OnInit,
    ViewEncapsulation,
    ViewRef,
    ViewChild,
} from "@angular/core";
import { Location } from "@angular/common";
import { EventService } from "../../services/event.service";
import { LockService } from "../../services/lock.service";
import { DropdownApi } from "../s25-dropdown/dropdown.api";
import { S25Util } from "../../util/s25-util";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { MultiselectResultsApi } from "../s25-multiselect/s25.multiselect.api";
import { HierarchyUtil } from "./s25.event.type.hierarchy.util";
import { EventTypeFormI } from "../../pojo/HierarchyI";
import { Api } from "../../api/api";
import { MasterDefinitionService } from "../../services/master.definitions/master.definition.service";
import { UserprefService } from "../../services/userpref.service";
import { NotificationPolicyMapper } from "../s25-notification-policy/notification.policy.mapper";
import { NotificationPolicyModel } from "../s25-notification-policy/notification.policy.model";
import { S25NotificationPolicyComponent } from "../s25-notification-policy/s25.notification.policy.component";
import { S25ModalComponent } from "../s25-modal/s25.modal.component";
import { AlertService } from "../../services/alert.service";
import { DropDownItem } from "../../pojo/DropDownItem";
import { Task } from "../../pojo/Task";
import { Report } from "../../pojo/Report";
import Use = Report.Use;
import ObjectType = Report.ObjectType;
import Reports = Report.Reports;

export class EventTypeApi extends Api {
    static refresh(relativeElem: HTMLElement) {
        return Api.callApiFn(relativeElem, "s25-ng-event-type", null, null, (comp: S25EventTypeComponent) => {
            comp && comp.ngOnInit();
        });
    }
}

@TypeManagerDecorator("s25-ng-event-type")
@Component({
    selector: "s25-ng-event-type",
    template: `
        @if (type === "E") {
            <h4 class="c-margin-top--half">{{ isEdit ? "Edit" : "New" }} Event Type</h4>
        }

        @if (init && eventType && reportsInit && type !== "view") {
            <div>
                @if (folders && !isEdit && !isCopy) {
                    <div>
                        <div>
                            <label class="c-margin-right--single c-margin-top--half cabinet-type">
                                <span class="ngBlock c-margin-bottom--quarter" id="cabinet"
                                    ><span class="ngBold">Cabinet Type </span
                                    ><span class="c-required">- Required</span></span
                                >
                                <s25-generic-dropdown
                                    [items]="cabinets"
                                    [placeholder]="'Select a Cabinet Type'"
                                    [searchEnabled]="true"
                                    [(value)]="chosenCabinet"
                                    (valueChange)="onChangeCabinet($event)"
                                />
                            </label>
                            <ng-container>
                                <label id="folder" class="folder-type">
                                    <span class="ngBlock c-margin-bottom--quarter c-margin-top--half ngBold"
                                        >Folder Type
                                    </span>
                                    <s25-ng-hierarch-dropdown
                                        [items]="folders"
                                        [searchEnabled]="true"
                                        [placeholder]="'Select a Folder Type'"
                                        [(value)]="chosenFolder"
                                        (valueChange)="onChangeFolder($event)"
                                    />
                                </label>
                                @if (folderTypeMsg !== "" && folders && folders.length) {
                                    <div class="c-margin-top--half  ngBold cn-alert cn-alert--warning">
                                        {{ folderTypeMsg }}
                                    </div>
                                }
                            </ng-container>
                        </div>
                    </div>
                }
                <label class="c-margin-right--double event-type c-margin-top--half ngBlock">
                    <span class="ngBold">Active</span>
                    <s25-toggle-button [(value)]="active" />
                </label>
                <label class="c-margin-right--double event-type c-margin-top--half">
                    <span class="ngBlock c-margin-bottom--quarter"
                        ><span class="ngBold">Event Type Name </span><span class="c-required">- Required</span></span
                    >
                    <input
                        type="text"
                        class="c-input cn-form__control"
                        name="type_name"
                        id="type_name"
                        [value]="eventType.type_name"
                        (change)="onChangeName($event)"
                        (focusout)="setFolderTypeMsg()"
                        maxlength="80"
                    />
                </label>
                <label class="vcal">
                    <span class="ngBold ngBlock c-margin-bottom--quarter c-margin-top--half">VCal Processing</span>
                    @if (vCalOptions) {
                        <select class="ngListPageDropdown" name="vCal" (change)="onChangeVCal($event)">
                            @for (v of vCalOptions; track v) {
                                <option [value]="v.val" [selected]="v.val === vCal">
                                    {{ v.txt }}
                                </option>
                            }
                        </select>
                    }
                </label>
                <label class="hierarchy--section-label  c-margin-bottom--none">Reports</label>
                <div class="hierarchy--flex-wrapper">
                    <span class="c-margin-right--double c-margin-bottom--half">
                        <label for="confir">Confirmation Notice</label>
                        <s25-generic-dropdown
                            [staticItems]="staticItems"
                            [items]="reportsDropdownList"
                            [placeholder]="'Select a Report'"
                            [searchEnabled]="true"
                            [(value)]="chosenConfirmation"
                            (valueChange)="onChangeReportDropdown($event)"
                        />
                    </span>
                    <span class="c-margin-bottom--half c-margin-right--double">
                        <label for="invoice">Invoice (Standard)</label>
                        <s25-generic-dropdown
                            [staticItems]="staticItems"
                            [items]="reportsDropdownList"
                            [placeholder]="'Select a Report'"
                            [searchEnabled]="true"
                            [(value)]="chosenInvoice"
                            (valueChange)="onChangeReportDropdown($event)"
                        />
                    </span>
                    <span class="c-margin-bottom--half c-margin-right--double">
                        <label for="invoice">Invoice (Payment)</label>
                        <s25-generic-dropdown
                            [staticItems]="staticItems"
                            [items]="paymentReportsDropdownList"
                            [placeholder]="'Select a Report'"
                            [searchEnabled]="true"
                            [(value)]="chosenInvoicePayment"
                            (valueChange)="onChangeReportDropdown($event)"
                        />
                    </span>
                </div>
                <s25-ng-multiselect-search-criteria
                    [selectedItems]="selectedReports"
                    [modelBean]="modelBeanReports"
                    honorMatching="true"
                    type="eventTypeReports"
                    (change)="onChangeReportsValue()"
                ></s25-ng-multiselect-search-criteria>
                @if (
                    eventContractBase.length > 0 ||
                    organizationContractBase.length > 0 ||
                    reservationContractBase.length > 0 ||
                    paymentContractBase.length > 0
                ) {
                    <div>
                        <s25-ng-icon [type]="'info'" [ariaLabel]="false" />
                    </div>
                }
                @for (contract of contractConfigs; track contract.label + "-" + $index) {
                    @if (contract.base.length > 0) {
                        <div class="c-margin-left--single">
                            If {{ contract.label }} is selected, then
                            <a class="c-textButton" (click)="openModal(contract)">
                                these document management reports
                            </a>
                            will be added to this event type.
                        </div>
                    }
                }
                <s25-ng-modal #docContractModal [title]="activeContract?.title" [size]="'xl'">
                    <ng-template #s25ModalBody>
                        @for (r of activeContract?.list; track r.report_id) {
                            <div>
                                {{ r.report_name }}
                            </div>
                        }
                    </ng-template>
                </s25-ng-modal>
                <label class="hierarchy--section-label" for="cat">Categories</label>
                <div id="cat">
                    <ng-container>
                        <s25-ng-multiselect-search-criteria
                            [selectedItems]="catSelectedItems"
                            [modelBean]="modelBeanCat"
                            honorMatching="true"
                            type="eventCategories"
                        ></s25-ng-multiselect-search-criteria>
                    </ng-container>
                </div>
                <label class="hierarchy--section-label" for="role">Contact Roles</label>
                <div id="role">
                    <ng-container>
                        <s25-ng-multiselect-search-criteria
                            [selectedItems]="roleSelectedItems"
                            [modelBean]="modelBeanRole"
                            honorMatching="true"
                            type="eventRoles"
                        ></s25-ng-multiselect-search-criteria>
                    </ng-container>
                </div>
                <label class="hierarchy--section-label" for="att">Custom Attributes</label>
                <div id="att">
                    <s25-ng-multiselect-search-criteria
                        [selectedItems]="attSelectedItems"
                        [modelBean]="modelBeanAtt"
                        honorMatching="true"
                        type="eventCustomAttributes"
                    ></s25-ng-multiselect-search-criteria>
                </div>
                <label class="hierarchy--section-label" for="req">Requirements (Publish to Calendar)</label>
                <div id="req">
                    <s25-ng-multiselect-search-criteria
                        [selectedItems]="reqSelectedItems"
                        [modelBean]="modelBeanReq"
                        honorMatching="true"
                        type="eventRequirements"
                        customFilterValue="requirement_type=7"
                    ></s25-ng-multiselect-search-criteria>
                </div>
                <label class="hierarchy--section-label" for="reqOther">Requirements (Other)</label>
                <div id="reqOther">
                    <s25-ng-multiselect-search-criteria
                        [selectedItems]="reqOtherSelectedItems"
                        [modelBean]="modelBeanReqOther"
                        honorMatching="true"
                        type="eventRequirements"
                        customFilterValue="requirement_type=6"
                    ></s25-ng-multiselect-search-criteria>
                </div>
                <label class="hierarchy--section-label" for="policy">Notification Policy</label>
                <div id="policy">
                    <s25-ng-notification-policy
                        [initialDraft]="notificationPolicyDraft"
                        [seededAsNew]="notificationPolicyIsNew"
                    ></s25-ng-notification-policy>
                </div>
                @if (!isCopy) {
                    <div class="c-displayBlock c-margin-top--single">
                        <button
                            class="aw-button aw-button--primary c-margin-top--single c-margin-right--quarter"
                            (click)="isCopy ? save(true) : save(false)"
                            [disabled]="!eventType.parent_id || !eventType.type_name"
                        >
                            <!-- {{ loading ? "Saving...." : "Save" }} -->
                            {{ saveButtonText }}
                        </button>
                        @if (isEdit) {
                            <button
                                class="aw-button aw-button--danger--outline c-margin-top--single c-margin-right--quarter"
                                (click)="confirm('isDelete')"
                            >
                                Delete
                            </button>
                        }
                        @if (isEdit && groupId === -1) {
                            <button
                                class="aw-button aw-button--danger--outline c-margin-top--single c-margin-right--quarter"
                                (click)="confirm('isForceDelete')"
                            >
                                Force Delete
                            </button>
                        }
                        @if (isEdit) {
                            <button
                                class="aw-button aw-button--outline c-margin-top--single c-margin-right--quarter"
                                (click)="copy()"
                            >
                                Copy
                            </button>
                        }
                        <button
                            class="aw-button aw-button--outline c-margin-top--single c-margin-right--quarter"
                            (click)="cancel()"
                        >
                            Cancel
                        </button>
                    </div>
                }
                @if (isCopy) {
                    <div>
                        <button
                            class="aw-button aw-button--primary c-margin-top--single c-margin-right--quarter"
                            (click)="save(true)"
                            [disabled]="!eventType.parent_id || !eventType.type_name || nameUsed"
                        >
                            Save Copy
                        </button>
                        <button
                            class="aw-button aw-button--outline c-margin-top--single c-margin-right--quarter"
                            (click)="cancelCopy()"
                        >
                            Cancel
                        </button>
                    </div>
                }
                @if (deleteConfirmed) {
                    <div>
                        <s25-ng-event-type-delete
                            (modelValueChange)="onChangeDeleteConfirm($event)"
                        ></s25-ng-event-type-delete>
                    </div>
                }
            </div>
        }

        <!-- cancel button if new got back the list -->

        @if (init && type === "view") {
            <div>
                <s25-ng-event-type-hierarchy resetType="true"></s25-ng-event-type-hierarchy>
            </div>
        }
    `,
    styles: `
        s25-generic-dropdown {
            min-width: 250px;
            display: block;
        }
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25EventTypeComponent implements OnInit {
    @Input() isEdit: any;
    @Input() eventTypeId: any;
    @Input() type: string = "E";
    @Input() itemTypeId: number = 1;
    @Input() isCopy?: boolean = false;
    valid: boolean;
    msg: any;
    eventType: EventTypeFormI = undefined;
    vCal = "U";
    vCalOptions = [
        { val: "U", txt: "Unlocked Transactional" },
        { val: "L", txt: "Locked Transactional" },
        { val: "N", txt: "Naturalize" },
    ];
    modelBeanRole: any = { showResult: true, showMatching: false };
    modelBeanCat: any = { showResult: true, showMatching: false };
    modelBeanAtt: any = { showResult: true, showMatching: false };
    modelBeanReq: any = { showResult: true, showMatching: false };
    modelBeanReqOther: any = { showResult: true, showMatching: false };
    reports: Report.Object[];
    reportsDropdownList: any;
    paymentReportsDropdownList: any;
    init = false;
    reportsInit = false;
    loading = false;
    allTypes: any;
    cabinets: any;
    parentId = 0;
    folders: any;
    chosenCabinet: any;
    notificationPolicyDraft: NotificationPolicyModel.FormModel | null = null;
    notificationPolicyIsNew = true;
    @ViewChild(S25NotificationPolicyComponent) notificationPolicyEditor?: S25NotificationPolicyComponent;
    roleSelectedItems = [
        { itemId: -2, itemName: "Scheduler", isPermanent: true },
        { itemId: -1, itemName: "Requestor", isPermanent: true },
    ];
    catSelectedItems: any = [];
    attSelectedItems: any = [];
    reqSelectedItems: any = [];
    reqOtherSelectedItems: any = [];
    roleSelectedItemsInit: any = [];
    catSelectedItemsInit: any = [];
    attSelectedItemsInit: any = [];
    reqSelectedItemsInit: any = [];
    reqOtherSelectedItemsInit: any = [];
    approvalTypes = [
        { itemName: "No Notification Policy", itemId: 0 },
        ...Task.NotificationPolicy.ApproverQuorumOptions,
    ];
    notifyTypes = [...Task.NotificationPolicy.ApproverQuorumOptions];
    chosenFolder: any;
    groupId: number;
    deleteConfirmed: boolean = false;
    isForceDelete: boolean = false;
    saveButtonText: string = "Save";
    folderTypeMsg: string = "";
    nameUsed: boolean = false;

    staticItems = [
        {
            dropDownOrigName: "No Default",
            isSelected: true,
            itemId: 0,
            itemName: "No Default",
            noAnchorClick: true,
            txt: "No Default",
            val: "",
        },
    ];
    chosenConfirmation: any = [];
    chosenInvoice: any = [];
    chosenInvoicePayment: DropDownItem = [];
    selectedReports: any = [];
    modelBeanReports: any = { showResult: true, showMatching: false, uuid: "selectedReports-uuid" };
    active: boolean = true; // Default to active for new event types

    @ViewChild("docContractModal") docContractModal: S25ModalComponent;

    eventContractBase: Report.Object[] = []; // report_id = -198 event contract shell report
    organizationContractBase: Report.Object[] = []; // report_id = -217 organization contract shell report
    reservationContractBase: Report.Object[] = []; // report_id = -210 reservation contract shell report
    paymentContractBase: Report.Object[] = []; // report_id = -236 invoice (payments) shell report
    eventContractList: Report.Object[] = [];
    organizationContractList: Report.Object[] = [];
    reservationContractList: Report.Object[] = [];
    paymentContractList: Report.Object[] = [];

    contractConfigs: ContractConfigI[] = [];
    activeContract: ContractConfigI;

    /* object_types are:
     event document (10), organization document (13), reservation document (12)
     event (1), org (2), contact (3), location (4), resource (6), pricing set (11)
    */

    constructor(
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef,
        private zone: NgZone,
        private location: Location,
    ) {}

    ngOnInit() {
        this.elementRef.nativeElement.angBridge = this; //bridge to AngularJS; used for AngJS to set model values and call setter fns
        this.zone.run(() => {
            if (this.itemTypeId === 1) {
                Promise.all([
                    this.getEventTypeReports(),
                    this.getGroupId(),
                    this.getAllEventTypes(),
                    !this.isEdit ? this.postEventType() : this.getEventTypeById(this.eventTypeId),
                    this.modelBeanRole.dataPromise && this.modelBeanRole.dataPromise,
                ]).then((resp) => {
                    this.setReportFields(); // prepopuation event form report fields after gathering all info
                    this.isCopy ? this.copy() : "";
                    this.modelBeanReports.onChange = () => {
                        this.onChangeReportsValue(); // check any base shell report
                    };
                    this.init = true;
                    this.detectChanges();
                });
            }
            this.detectChanges();
        });
    }

    setFolderTypeMsg() {
        this.chosenFolder === "" && this.folders !== ""
            ? (this.folderTypeMsg = "Folder type has not been selected.")
            : (this.folderTypeMsg = "");
    }

    getAllEventTypes() {
        return EventService.getAllEventType().then((data) => {
            this.allTypes = data;
            this.cabinets = HierarchyUtil.decorateItems(this.allTypes, "C", "node_type", 0);
            this.folders = HierarchyUtil.decorateItems(this.allTypes, "F", "node_name");
        });
    }

    postEventType() {
        this.initFunc(); // reset some vars
        return EventService.postEventType().then((data) => {
            this.eventType = data as any;
            this.eventType.inheritance_rules = HierarchyUtil.inheritanceRules(); // set inheritanceRules default values
            this.detectChanges();
        });
    }

    getEventTypeById(id: any) {
        return EventService.getEventTypeById(id).then((data) => {
            this.eventType = data;
            this.eventType.contact_role
                ? (this.roleSelectedItems = HierarchyUtil.decorateSelectedItems(
                      this.eventType.contact_role,
                      "role_id",
                      "role_name",
                  ))
                : "";
            this.eventType.categories
                ? (this.catSelectedItems = HierarchyUtil.decorateSelectedItems(
                      this.eventType.categories,
                      "category_id",
                      "category_name",
                  ))
                : "";
            this.eventType.custom_attributes
                ? (this.attSelectedItems = HierarchyUtil.decorateSelectedItems(
                      this.eventType.custom_attributes,
                      "attribute_id",
                      "attribute_name",
                  ))
                : "";
            const getVCal: any = S25Util.array.getByProp(this.eventType.inheritance_rules, "inherit_item", "Vcal");
            this.vCal = getVCal?.vcal || "U";

            if (this.eventType.requirements) {
                let reqCal: any;
                let reqOther: any;
                const getAllReq: any = this.eventType.requirements;
                if (S25Util.array.isArray(this.eventType.requirements)) {
                    reqCal = this.eventType.requirements.filter((i: any) => i.requirement_type === 7);
                    reqOther = this.eventType.requirements.filter((i: any) => i.requirement_type === 6);
                } else {
                    getAllReq.requirement_type === 7
                        ? (reqCal = this.eventType.requirements)
                        : (reqOther = this.eventType.requirements);
                }
                if (reqCal) {
                    this.reqSelectedItems = HierarchyUtil.decorateSelectedItems(
                        reqCal,
                        "requirement_id",
                        "requirement",
                    );
                }
                if (reqOther) {
                    this.reqOtherSelectedItems = HierarchyUtil.decorateSelectedItems(
                        reqOther,
                        "requirement_id",
                        "requirement",
                    );
                }
            }

            if (this.eventType.notifications) {
                this.notificationPolicyDraft = NotificationPolicyMapper.draftFromPolicyLike(
                    this.eventType.notifications,
                );
                this.notificationPolicyIsNew = false;
            } else {
                this.notificationPolicyDraft = NotificationPolicyMapper.emptyDraft();
                this.notificationPolicyIsNew = true;
            }

            this.roleSelectedItemsInit = S25Util.deepCopy(this.roleSelectedItems);
            this.catSelectedItemsInit = S25Util.deepCopy(this.catSelectedItems);
            this.attSelectedItemsInit = S25Util.deepCopy(this.attSelectedItems);
            this.reqSelectedItemsInit = S25Util.deepCopy(this.reqSelectedItems);
            this.reqOtherSelectedItemsInit = S25Util.deepCopy(this.reqOtherSelectedItems);

            this.active = this.eventType.defn_state === 1;

            this.detectChanges();
        });
    }

    onChangeName(e: any) {
        this.eventType.type_name = e.target.value;
        this.detectChanges();
    }

    onChangeVCal(e: any) {
        this.eventType.inheritance_rules = this.eventType.inheritance_rules.map((r: any) => {
            if (r.inherit_item === "Vcal") {
                r.inherit_rule = e.target.value;
                r.vcal = e.target.value;
            }
            return r;
        });
        this.detectChanges();
    }

    onChangeReportDropdown(e: any) {
        //if new selected confirmation/invoice report not in multiselected,  add to the list
        const find = this.selectedReports.filter((item: any) => item.itemId === e.itemId);
        if (find.length === 0 && e.itemId !== 0) this.selectedReports.push(e); // no default itemId = 0
        //reset confirmation and invoice reports in multiselect not allow to remove
        this.selectedReports.map((item: any) => {
            // if report us confirmation/invoice, not allow to remove from multi selected
            const isConfirmation = item.itemId === this.chosenConfirmation.itemId;
            const isInvoice = item.itemId === this.chosenInvoice.itemId;
            const isPayment = item.itemId === this.chosenInvoicePayment.itemId;
            item.isPermanent = isConfirmation || isInvoice || isPayment;
            return item;
        });
        MultiselectResultsApi.refresh(this.elementRef.nativeElement, "selectedReports-uuid");
    }

    onChangeCabinet(e: any) {
        this.chosenFolder = "";
        //this.eventType.parent_id = null;
        this.eventType.parent_id = e.itemId; //ANG4191
        this.folders = this.allTypes.filter((i: any) => i.parent_id === e.itemId && i.node_type === "F");
        this.folders = this.folders.map((obj: any) => {
            return { itemName: obj.type_name, itemId: obj.type_id };
        });
        const el: any = "s25-ng-hierarch-dropdown";
        DropdownApi.refresh(el, this.folders);
        this.detectChanges();
    }

    onChangeFolder(e: any) {
        this.eventType.parent_id = e.itemId;
        this.folderTypeMsg = "";
        this.detectChanges();
    }

    view() {
        this.location.back();
    }

    save(isCopy?: boolean) {
        // isCopy = ture from Copy function
        if (this.validate()) {
            this.loading = true;
            isCopy ? (this.saveButtonText = "Copying...") : (this.saveButtonText = "Saving...");
            this.cd.detectChanges();
            this.eventType.node_type = "E";
            this.eventType.defn_state = this.active ? 1 : 0;
            if (this.isEdit) {
                this.eventType.status = "mod";
            } else {
                this.eventType.status = "new";
                if (!isCopy) {
                    delete this.eventType.notifications;
                    delete this.eventType.class_name;
                    delete this.eventType.favorite;
                    delete this.eventType.last_mod_dt;
                    delete this.eventType.last_mod_user;
                    delete this.eventType.node_type_name;
                    delete this.eventType.routing_rules;
                    delete this.eventType.sort_order;
                    delete this.eventType.routing_rules;
                    delete this.eventType.tag_value;
                }
            }

            const reports = [];
            let use: Use = Use.None;
            //set selected report
            for (let j = 0; j < this.selectedReports.length; j++) {
                let status = "mod";
                !S25Util.array.isIn(this.eventType.reports, "report_id", parseInt(this.selectedReports[j].itemId))
                    ? (status = "new")
                    : "";

                if (this.selectedReports[j].itemId === this.chosenConfirmation.report_id) {
                    use = Use.Confirmation;
                } else if (this.selectedReports[j].itemId === this.chosenInvoice.report_id) {
                    use = Use.Invoice;
                } else if (this.selectedReports[j].itemId === this.chosenInvoicePayment.report_id) {
                    use = Use.Payment;
                } else {
                    use = Use.None;
                }

                reports.push({
                    report_engine: this.selectedReports[j].report_engine,
                    report_id: this.selectedReports[j].report_id,
                    report_name: this.selectedReports[j].report_name,
                    report_use: use,
                    status: status,
                });
            }
            // set removed report
            if (this.modelBeanReports.removedItems.length > 0) {
                for (let r = 0; r < this.modelBeanReports.removedItems.length; r++) {
                    if (
                        S25Util.array.isIn(
                            this.eventType.reports,
                            "report_id",
                            parseInt(this.modelBeanReports.removedItems[r].itemId),
                        )
                    ) {
                        if (!isCopy) {
                            reports.push({
                                report_engine: this.modelBeanReports.removedItems[r].report_engine,
                                report_id: this.modelBeanReports.removedItems[r].report_id,
                                report_name: this.modelBeanReports.removedItems[r].report_name,
                                report_use: use,
                                status: "del",
                            });
                        }
                    }
                }
            }
            // end report

            !S25Util.array.isEmpty(reports) ? (this.eventType.reports = reports) : "";
            S25Util.array.isEmpty(reports) ? delete this.eventType.reports : "";

            const policyDraft =
                this.notificationPolicyEditor?.getSession().draft ?? NotificationPolicyMapper.emptyDraft();
            const notifications = NotificationPolicyMapper.eventTypeNotificationsFromDraft(
                policyDraft,
                this.eventType.notifications,
            );
            if (notifications) {
                this.eventType.notifications = notifications;
            } else if (!policyDraft.approvalType?.itemId && this.eventType.notifications?.approval_from) {
                //ANG-6545 be sure that notifications won't be an empty string when otherwise defined
                this.eventType.notifications.respond_within = this.eventType.notifications.respond_within || "P0D";
            }

            let req: any = [];
            let otherReq: any = [];
            if (this.modelBeanReq.selectedItems) {
                req = HierarchyUtil.decorateItemsToSave(
                    this.modelBeanReq.selectedItems,
                    this.reqSelectedItemsInit,
                    this.modelBeanReq.removedItems,
                    "requirement_id",
                    "requirement",
                    this.isEdit,
                    "requirement_type",
                    6,
                );
            }
            if (this.modelBeanReqOther.selectedItems) {
                otherReq = HierarchyUtil.decorateItemsToSave(
                    this.modelBeanReqOther.selectedItems,
                    this.reqOtherSelectedItemsInit,
                    this.modelBeanReqOther.removedItems,
                    "requirement_id",
                    "requirement",
                    this.isEdit,
                    "requirement_type",
                    7,
                );
            }
            this.eventType.requirements = req.concat(otherReq);
            S25Util.array.isEmpty(this.eventType.requirements) ? delete this.eventType.requirements : "";

            if (this.modelBeanCat.selectedItems) {
                this.eventType.categories = HierarchyUtil.decorateItemsToSave(
                    this.modelBeanCat.selectedItems,
                    this.catSelectedItemsInit,
                    this.modelBeanCat.removedItems,
                    "category_id",
                    "category_name",
                    this.isEdit,
                );
            }
            S25Util.array.isEmpty(this.eventType.categories) ? delete this.eventType.categories : "";

            if (this.modelBeanRole.selectedItems) {
                this.eventType.contact_role = HierarchyUtil.decorateItemsToSave(
                    this.modelBeanRole.selectedItems,
                    this.roleSelectedItemsInit,
                    this.modelBeanRole.removedItems,
                    "role_id",
                    "role_name",
                    this.isEdit,
                );
            }
            S25Util.array.isEmpty(this.eventType.contact_role) ? delete this.eventType.contact_role : "";

            if (this.modelBeanAtt.selectedItems) {
                this.eventType.custom_attributes = HierarchyUtil.decorateItemsToSave(
                    this.modelBeanAtt.selectedItems,
                    this.attSelectedItemsInit,
                    this.modelBeanAtt.removedItems,
                    "attribute_id",
                    "attribute_name",
                    this.isEdit,
                );
            }
            S25Util.array.isEmpty(this.eventType.custom_attributes) ? delete this.eventType.custom_attributes : "";

            LockService.lock(1005, 1101);

            let saveMsg = "ET_I_CREATED";
            this.isEdit ? (saveMsg = "ET_I_SAVED") : "";

            EventService.putEventType(this.eventType.type_id, this.eventType, saveMsg).then((resp) => {
                if (resp && resp.success) {
                    this.loading = false;
                    this.isCopy = false;
                    this.saveButtonText = "Save";
                    LockService.delete(1101, 1005);
                    if (!this.isEdit) {
                        this.isEdit = true;
                        this.eventTypeId = this.eventType.type_id;
                        //this.ngOnInit(); // new event type just created, Init again to update some vars
                    }
                    this.type = "view";
                    if (this.eventType.node_type && this.eventType.type_id) {
                        //return to hierarchy on save with new folder/cabinet highlighted
                        const hierarchyUrl =
                            HierarchyUtil.getCompUrl("hierarchy") +
                            "/" +
                            this.itemTypeId +
                            "/view/" +
                            this.eventType.node_type +
                            "/" +
                            this.eventType.type_id;
                        window.location.assign(hierarchyUrl);
                    }
                    console.log("Update done");
                    //}
                    //window.location.reload();
                    this.detectChanges();
                }
            });
        } //endif valid
    }

    cancel() {
        let id = this.eventType.type_id;
        this.isCopy = false;
        !this.isEdit ? (id = 1) : "";
        const hierarchyUrl =
            HierarchyUtil.getCompUrl("hierarchy") + "/" + this.itemTypeId + "/view/E/" + this.eventType.type_id;
        window.location.assign(hierarchyUrl);
        /*
		this.init = false;  // set back to false, tried MultiselectApi.refresh but did not make changes
		this.initFunc();
		this.ngOnInit();
		this.detectChanges();
          setTimeout(() => {
               this.location.back();
          }, 120);
          */
    }

    cancelCopy() {
        let id = this.eventType.type_id;
        this.isCopy = false;
        !this.isEdit ? (id = 1) : "";
        history.back();
    }

    delete() {
        const payload = {
            type_id: this.eventType.type_id,
            status: "del",
        };

        return AlertService.confirm("Are you sure you want to delete this event type?").then((answer: boolean) => {
            if (answer) {
                LockService.lock(1005, 1101);
                return EventService.putEventType(this.eventType.type_id, payload, "ET_I_DELETED").then((resp) => {
                    if (resp && resp.success) {
                        LockService.delete(1101, 1005);
                        alert("Event type has been deleted.");
                        const hierarchyUrl =
                            HierarchyUtil.getCompUrl("hierarchy") +
                            "/" +
                            this.itemTypeId +
                            "/view/" +
                            this.eventType.node_type +
                            "/0";
                        window.location.assign(hierarchyUrl);
                        window.location.reload();
                    }
                });
            }
        });
    }

    forceDelete() {
        return AlertService.confirm(
            "Are you sure that you want to delete this master definition and remove all references to it?",
        ).then((answer) => {
            if (answer) {
                LockService.lock(1005, 1101);
                return MasterDefinitionService.forceDelete("event_type", this.eventType.type_id).then((resp: any) => {
                    LockService.delete(1101, 1005);
                    alert("Event type has been deleted.");
                    const hierarchyUrl =
                        HierarchyUtil.getCompUrl("hierarchy") +
                        "/" +
                        this.itemTypeId +
                        "/view/" +
                        this.eventType.node_type +
                        "/0";
                    window.location.assign(hierarchyUrl);
                    window.location.reload();
                });
            }
        });
    }

    confirm(e: any) {
        this.deleteConfirmed = true;
        e === "isForceDelete" ? (this.isForceDelete = true) : (this.isForceDelete = false);
    }

    onChangeDeleteConfirm(e: any) {
        if (e === "confirmed") {
            this.isForceDelete ? this.forceDelete() : this.delete();
        } else {
            this.deleteConfirmed = false;
        }
    }

    copy() {
        //ANG-3822 make sure no event type name NOT in use
        const find = this.allTypes.find((a: any) => {
            return a && a.type_name === "Copy of " + this.eventType.type_name;
        });

        if (find) {
            this.nameUsed = true;
            alert(
                "Copy of " +
                    this.eventType.type_name +
                    " has already been used for another type.  Please specify a unique name for the type.",
            );
        } else {
            this.nameUsed = false;
            return EventService.postEventType().then((data) => {
                this.eventType.type_id = data.type_id;
                this.eventType.type_name = "Copy of " + this.eventType.type_name;
                this.isEdit = false;
                this.isCopy = true;
                this.saveButtonText = "Save Copy";
                window.scrollTo(0, 0); // per Shannon make it consistent as List View copy, users can easily tell that they can make changes to the copy before saving
                this.detectChanges();
            });
        }
    }

    getEventTypeReports() {
        return EventService.getEventTypeReports().then((data: any) => {
            this.reports = data;
            this.reportsInit = true;
        });
    }

    setReportFields() {
        this.eventType.reports = S25Util.array.forceArray(this.eventType.reports);
        this.eventContractBase = this.eventType.reports.filter(
            (item: any) => item?.report_id === Reports.EventShell.id,
        );
        this.organizationContractBase = this.eventType.reports.filter(
            (item: any) => item?.report_id === Reports.OrganizationShell.id,
        );
        this.reservationContractBase = this.eventType.reports.filter(
            (item: any) => item?.report_id === Reports.ReservationShell.id,
        );
        this.paymentContractBase = this.eventType.reports.filter(
            (item: any) => item?.report_id === Reports.PaymentShell.id,
        );
        // mapping itemId and itemName for generic-dropdown

        const uses = [Use.Confirmation, Use.Invoice, Use.Payment];
        for (const report of this.eventType.reports) {
            report.object_type = report.object_type_id; // object_type is needed for normalizeReport
            // if report is confirmation/invoice/payment, not allow to remove from multi selected
            if (uses.includes(report.report_use)) report.isPermanent = true;
        }
        Report.Obj.normalizeReports(this.eventType.reports);
        this.selectedReports = [...this.eventType.reports];
        const chosenConfirmation = this.eventType.reports.filter((item: any) => item?.report_use === Use.Confirmation);
        const chosenInvoice = this.eventType.reports.filter((item: any) => item?.report_use === Use.Invoice);
        const chosenInvoicePayment = this.eventType.reports.filter((item: any) => item?.report_use === Use.Payment);
        if (chosenConfirmation.length !== 0) this.chosenConfirmation = chosenConfirmation[0];
        if (chosenInvoice.length !== 0) this.chosenInvoice = chosenInvoice[0];
        if (chosenInvoicePayment.length !== 0) this.chosenInvoicePayment = chosenInvoicePayment[0];

        this.reports = Report.Obj.normalizeReports(this.reports, true);
        //report dropdown list. ANG-4917 include DM reports but no reservation reports (object type = 12_) ,  also no shell base reports
        const objectTypes = [ObjectType.Event, ObjectType.EventDocument, ObjectType.OrganizationDocument];
        this.reportsDropdownList = this.reports.filter(
            (item: any) =>
                objectTypes.indexOf(item.object_type) > -1 &&
                item.report_id !== Reports.OrganizationShell.id &&
                item.report_id !== Reports.ReservationShell.id &&
                item.report_id !== Reports.EventShell.id,
        );
        this.paymentReportsDropdownList = this.reports.filter((report) => {
            const isPaymentReport = Number(report.object_type) === ObjectType.PaymentDocument;
            const isShell = Number(report.report_id) === Reports.PaymentShell.id;
            return isPaymentReport && !isShell;
        });

        this.eventContractList = this.reports.filter(
            (item: any) => item.object_type === ObjectType.EventDocument && item.report_id !== Reports.EventShell.id,
        );
        this.organizationContractList = this.reports.filter(
            (item: any) =>
                item.object_type === ObjectType.OrganizationDocument && item.report_id !== Reports.OrganizationShell.id,
        );
        this.reservationContractList = this.reports.filter(
            (item: any) =>
                item.object_type === ObjectType.ReservationDocument && item.report_id !== Reports.ReservationShell.id,
        );
        this.paymentContractList = this.reports.filter(
            (item: any) =>
                item.object_type === ObjectType.PaymentDocument &&
                item.report_id !== Reports.PaymentShell.id &&
                item.report_engine === "DM",
        );

        this.getcontractConfigs();

        this.cd.detectChanges();
    }

    onChangeReportsValue() {
        this.eventContractBase = this.modelBeanReports.selectedItems.filter(
            (item: any) => item?.report_id === Reports.EventShell.id,
        );
        this.organizationContractBase = this.modelBeanReports.selectedItems.filter(
            (item: any) => item?.report_id === Reports.OrganizationShell.id,
        );
        this.reservationContractBase = this.modelBeanReports.selectedItems.filter(
            (item: any) => item?.report_id === Reports.ReservationShell.id,
        );
        this.paymentContractBase = this.modelBeanReports.selectedItems.filter(
            (item: any) => item?.report_id === Reports.PaymentShell.id,
        );
        this.getcontractConfigs();
        this.detectChanges();
    }

    validate() {
        this.msg = "";
        if (!this.eventType.parent_id && !this.isEdit) {
            this.msg = "Please select a folder";
            alert(this.msg);
            this.valid = false;
            return false;
        }

        if (!this.eventType.type_name) {
            this.msg = "Event type name is required";
            alert(this.msg);
            this.valid = false;
            return false;
        }

        const policyDraft = this.notificationPolicyEditor?.getSession().draft ?? NotificationPolicyMapper.emptyDraft();
        if (
            policyDraft.approvalType?.itemId &&
            policyDraft.approvalType.itemId !== NotificationPolicyMapper.REMOVED_ID
        ) {
            return this.notificationPolicyEditor?.validate() ?? true;
        }
        return true;
    }

    initFunc() {
        this.notificationPolicyDraft = NotificationPolicyMapper.emptyDraft();
        this.notificationPolicyIsNew = true;
        this.catSelectedItems = [];
        this.attSelectedItems = [];
        this.reqSelectedItems = [];
        this.reqOtherSelectedItems = [];
        this.roleSelectedItemsInit = [];
        this.catSelectedItemsInit = [];
        this.attSelectedItemsInit = [];
        this.reqSelectedItemsInit = [];
        this.reqOtherSelectedItemsInit = [];
    }

    getGroupId() {
        return UserprefService.getGroupId().then((resp: any) => {
            resp ? (this.groupId = resp) : "";
            this.detectChanges();
        });
    }

    detectChanges() {
        this.cd && !(this.cd as ViewRef).destroyed && this.cd.detectChanges();
    }

    getcontractConfigs() {
        this.contractConfigs = [
            {
                label: "Event Contract",
                base: this.eventContractBase,
                list: this.eventContractList,
                modalRef: this.docContractModal,
                modalName: "docContractModal",
                title: "Event-Based Documents",
            },
            {
                label: "Event Organization Shell",
                base: this.organizationContractBase,
                list: this.organizationContractList,
                modalRef: this.docContractModal,
                modalName: "docOrgContractModal",
                title: "Organization-Based Documents",
            },
            {
                label: "Reservation Shell",
                base: this.reservationContractBase,
                list: this.reservationContractList,
                modalRef: this.docContractModal,
                modalName: "docResContractModal",
                title: "Reservation-Based Documents",
            },
            {
                label: "Invoice (Payments) Shell",
                base: this.paymentContractBase,
                list: this.paymentContractList,
                modalRef: this.docContractModal,
                modalName: "docPaymentContractModal",
                title: "Invoice-Based Documents",
            },
        ];
    }

    openModal(contract: ContractConfigI) {
        this.activeContract = contract;
        this.docContractModal.open();
    }
}

export type ContractConfigI = {
    label: string;
    base: Report.Object[];
    list: Report.Object[];
    modalRef: S25ModalComponent;
    modalName: string;
    title: string;
};
